import { SelectHTMLAttributes, forwardRef } from 'react';
import { clsx } from 'clsx';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
  error?: string;
}

const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, options, error, className, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-900 mb-2">
            {label}
          </label>
        )}
        <select
          className={clsx(
            'w-full px-4 py-3 border border-gray-300 rounded-sm',
            'focus:outline-none focus:ring-2 focus:ring-jungle-600 focus:border-transparent',
            'transition-all duration-200',
            'text-gray-900 bg-white',
            'appearance-none cursor-pointer',
            'bg-[url("data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%20width=\'12\'%20height=\'6\'%3E%3Cpath%20d=\'M0%200l6%206%206-6z\'%20fill=\'%23333333\'/%3E%3C/svg%3E")]',
            'bg-no-repeat bg-[center_right_1rem]',
            error && 'border-red-500',
            className
          )}
          ref={ref}
          {...props}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && (
          <p className="mt-1 text-sm text-red-500">{error}</p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;
